import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { ResultOption } from './result-option.component';

import { Place } from '@/types/google-maps.types';
import { defaultPlace } from '@/app/(main)/(pages)/(home)/_consts/default-places.const';
import { Typography } from '@/components/ui/typography/typography.component';

type InitialLocationSuggestionsProps = {
  handleLocationClick: (item: Place) => Promise<void>;
};

export const InitialLocationSuggestions = ({
  handleLocationClick,
}: InitialLocationSuggestionsProps) => {
  return (
    <div
      className="flex flex-col gap-5"
      data-testid={DataTestIdEnum.LOCATION_INITIAL_SUGGESTIONS}
    >
      <Typography className="font-semibold">
        Cidades mais pesquisadas
      </Typography>

      {defaultPlace.map((place) => (
        <ResultOption
          key={`key-location-${place.city}`}
          description={place.formattedAddress}
          callback={async () => {
            await handleLocationClick(place);
          }}
        />
      ))}
    </div>
  );
};
